import { render, staticRenderFns } from "./rhPhoneExchangeRecord.vue?vue&type=template&id=728acf84"
import script from "./rhPhoneExchangeRecord.vue?vue&type=script&lang=js"
export * from "./rhPhoneExchangeRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports